import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchAllLabTests = createAsyncThunk(
    'labTests/fetchAllLabTests',
    async(_, thunkAPI) => {
        try{
            const res = await fetch(`/api/v1/lab_tests`);
            if(!res.ok) throw new Error("Failed to fetch lab tests");
            return await res.json();
            //console.log("Fetched lab tests:", res);
         } catch (err){
            return thunkAPI.rejectWithValue(err.message);
         }
    }
);

//fetch lab tests for a specific patient
export const fetchLabTests = createAsyncThunk(
    'labTests/fetchLabTests',
    async(patientId, thunkAPI) => {
        try{
            const res = await fetch(`/api/v1/lab_tests?patient_id=${patientId}`);
            if(!res.ok) throw new Error("Failed to fetch lab tests");
            return await res.json();
         } catch (err){
            return thunkAPI.rejectWithValue(err.message);
         }
    }
);

// Fetch only pending lab tests
export const fetchPendingLabTests = createAsyncThunk(
  'labTests/fetchPendingLabTests',
  async (_, thunkAPI) => {
    try {
      const res = await fetch('/api/v1/lab_tests?status=pending');
      if (!res.ok) throw new Error('Failed to fetch pending lab tests');
      return await res.json();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

//save a new lab test
export const createLabTest = createAsyncThunk(
    'labTests/saveLabTest',
    async ( labTestData, thunkAPI) => {
        try{
            const res = await fetch(`/api/v1/lab_tests`,{
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify({ lab_test: labTestData})
            });
 
             if (!res.ok) throw new Error('Failed to create lab test');
             return await res.json();            
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message);
        }
    }
);

const initialState = {
    list: [],
    loading: false,
    submitting: false,
    error: null
}

const labTestSlice = createSlice({
    name: 'labTests',
    initialState,
    reducers: {
       addLabTest(state, action) {
        const newTest = action.payload;
        const exists = state.list.find((t) => t.id === newTest.id);
        if (!exists) {
            state.list.unshift(newTest);
        }
        },

        updateLabTest(state,action) {
            const updated = action.payload;
            
            state.list = state.list.map((test) =>
             test.id === updated.id
                ? { ...test, ...updated }
                : test
            );
        },
        deleteLabTest(state, action) {
            const id = action.payload;
            state.list = state.list.filter((test) => test.id !== id);
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchLabTests.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchLabTests.fulfilled, (state,action) => {
            state.loading = false;
            state.list = action.payload;
        })
        .addCase(fetchLabTests.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(createLabTest.pending, (state) => {
            state.submitting = true;
            state.error = null;
        })
        .addCase(createLabTest.fulfilled, (state, action) => {
        state.submitting = false;
        const newTest = action.payload;
        const exists = state.list.find((t) => t.id === newTest.id);
        if (!exists) {
            state.list.unshift(newTest);
        }
        })
        .addCase(createLabTest.rejected, (state, action) => {
            state.submitting = false;
            state.error = action.payload;
        })
        .addCase(fetchPendingLabTests.pending, (state) => {
        state.loading = true;
        state.error = null;
        })
        .addCase(fetchPendingLabTests.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        })
        .addCase(fetchPendingLabTests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        })
        .addCase(fetchAllLabTests.pending, (state) => {
        state.loading = true;
        state.error = null;
        })
        .addCase(fetchAllLabTests.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        })
        .addCase(fetchAllLabTests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        });
    },
});

export const {
    addLabTest, updateLabTest, deleteLabTest
} = labTestSlice.actions;

export const selectLabTests = (state) => state.labTests.list;
export const selectLabTestsLoading = (state) => state.labTests.loading;
export const selectLabTestsSubmitting = (state) => state.labTests.submitting;
export const selectLabTestsError = (state) => state.labTests.error;


export default labTestSlice.reducer;